export const STARTER_POLL_INTERVAL_MS = 5000;
export const STARTER_POLL_TIMEOUT_MS = 90000;

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function toStarter(template) {
  const required = (template.input_schema || [])
    .filter((f) => f && f.required && f.label)
    .map((f) => f.label);
  return {
    id: template.id,
    title: template.template_name,
    youAdd: required.length ? required.join(', ') : null,
  };
}

export function toSavedTask(template) {
  return {
    id: template.id,
    title: template.template_name,
    steps: template.node_count || 0,
    lastUsedAt: template.last_used_at ?? template.updated_at ?? template.created_at ?? null,
    pinned: !!template.pinned,
    lastRun: template.last_run ?? null,
  };
}

const time = (iso) => (iso ? new Date(iso).getTime() : null);

export function sortSavedTasks(tasks) {
  return [...tasks].sort((a, b) => {
    if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
    const ta = time(a.lastUsedAt);
    const tb = time(b.lastUsedAt);
    if (ta === tb) return 0;
    if (ta === null) return 1;
    if (tb === null) return -1;
    return tb - ta;
  });
}

export function toRecentCanvases(flows, limit = 4) {
  return [...(flows || [])]
    .sort((a, b) => (time(b.updated_at) ?? 0) - (time(a.updated_at) ?? 0))
    .slice(0, limit)
    .map((f) => ({ id: f.id, title: f.name || 'Untitled canvas', updatedAt: f.updated_at }));
}

export function greeting(date, fullName) {
  const h = date.getUTCHours();
  const word = h < 12 ? 'Morning' : h < 18 ? 'Afternoon' : 'Evening';
  const first = (fullName || '').trim().split(/\s+/)[0];
  return first ? `${word}, ${first}.` : `${word}.`;
}

export function roleShort(role) {
  if (!role) return '';
  return role.split(/ — | - |,|\(/)[0].trim();
}

export function formatRanAt(iso, now) {
  const then = new Date(iso);
  const ms = now.getTime() - then.getTime();
  const HOUR = 3600000;
  if (ms < HOUR) return 'just now';
  if (ms < 24 * HOUR) return `${Math.floor(ms / HOUR)}h ago`;
  if (ms < 7 * 24 * HOUR) return `${DAYS[then.getUTCDay()]} UTC`;
  return `${then.getUTCDate()} ${MONTHS[then.getUTCMonth()]} UTC`;
}
